module.exports = __webpack_public_path__ + "static/media/visa_logo.b5c37760.png";